import { createSlice } from '@reduxjs/toolkit';

const compareSlice = createSlice({
  name: 'compare',
  initialState: {
    selectedData: [], // List of selected products
  },
  reducers: {
    toggleProductSelection: (state, action) => {
      const product = action.payload;
      const isAlreadySelected = state.selectedData.some((p) => p._id === product._id);

      if (isAlreadySelected) {
        state.selectedData = state.selectedData.filter((p) => p._id !== product._id);
      } else {
        state.selectedData.push(product);
      }
    },
    setSelectedData: (state, action) => {
      state.selectedData = action.payload;
    },
  },
});

export const { toggleProductSelection, setSelectedData } = compareSlice.actions;
export default compareSlice.reducer;
